import bloggif from "../../componets/assets/images/blogif2.gif";
import { FaHeart, FaComment, FaShare } from "react-icons/fa";
import postlists from "../posts/post1.json";
import { useNavigate } from "react-router-dom";

export default function PostList() {
  const navigate = useNavigate();
  return (
    <>
      {postlists.length > 0 ? (
        postlists.map((post, index) => (
          <div
            className="md:w-1/2 p-5 flex flex-col-reverse sm:flex-row gap-4 md:gap-10 cursor-pointer border-b border-gray-700 "
            key={index}
            onClick={() => navigate(`/blog/${post.id}`)}
          >
            <div className="space-y-2">
              <h1 className="text-[#5126c7] text-2xl font-extrabold">
                {post.title}
              </h1>
              <div>
                <p className="text-[#000000] text-xs md:text-sm">{post.subTitle}</p>
                <p className="text-xs text-zinc-500">
                  {post.date} - <span>{post.author}</span>
                </p>
              </div>
              <div className="flex gap-10 pt-2">
                <FaHeart
                  className="text-transparent text-xs"
                  stroke="rgb(55 65 81)"
                  strokeWidth="10"
                />
                <FaComment
                  className="text-transparent text-xs"
                  stroke="rgb(55 65 81)"
                  strokeWidth="10"
                />
                <FaShare
                  className="text-transparent text-xs"
                  stroke="rgb(55 65 81)"
                  strokeWidth="10"
                />
              </div>
            </div>
            <div className="">
              <img className="w-48 rounded-lg" src={post.image} />
            </div>
          </div>
        ))
      ) : (
        <div className="md:w-1/2 p-5 flex flex-col-reverse sm:flex-row gap-4 md:gap-10 cursor-pointer border-y border-gray-700 ">
          <div className="space-y-2">
            <h1 className="text-[#5126c7] text-2xl font-extrabold">
              No posts found
            </h1>
          </div>
        </div>
      )}
    </>
  );
}
